// extracted by mini-css-extract-plugin
export default {"text":"About_text__cMHsf","image":"About_image__7K65i","fade-in":"About_fade-in__hxug+"};